import CreateAccount from "@onboarding2/svelte/Start/CreateAccount.svelte";
import Details from "@onboarding2/svelte/Start/Details.svelte";
import DetailsManual from "@onboarding2/svelte/Start/DetailsManual.svelte";
import Distributors from "@onboarding2/svelte/Start/Distributors.svelte";
import DistributorStore from "@shared/svelte/Stores/DistributorsStore";
import PasswordReset from "@onboarding2/svelte/Start/PasswordReset.svelte";
import PasswordResetSent from "@onboarding2/svelte/Start/PasswordResetSent.svelte";
import ReferralRetailerConfirmation from "@onboarding2/svelte/RetailerDetails/ReferralRetailerConfirmation.svelte";
import SalesforceChat from "@shared/services/salesforce_chat";
import SalesRep from "@onboarding2/svelte/Start/SalesRep.svelte";
import SignUp from "@onboarding2/svelte/Start/SignUp.svelte";
import { OnboardingSessionStore } from "@onboarding2/svelte/Stores/OnboardingSessionStore";
import { OnboardingUserType } from "@shared/types/OnboardingSession";

window.tiz.config([
  "$locationProvider",
  "$stateProvider",
  function ($locationProvider, $stateProvider) {
    $locationProvider.html5Mode(true);

    $stateProvider.state("layout", {
      abstract: true,
      template: `<div ui-view style="min-height: 100%;" class="fizz-surface-gray"></div>`,
      resolve: {
        retailers: [
          "$rootScope",
          "$q",
          "userInfo",
          "Retailers",
          ($rootScope, $q, userInfo, Retailers) => Retailers.load(),
          // unused arguments are angular boilerplate necessary for dependency injection
        ],
        userInfo: ["User", User => User.loadOnboarding()],
        salesforceChat: [
          function () {
            SalesforceChat.initialize();
          },
        ],
      },
    });

    $stateProvider.state("layout.signup", {
      url: "/start/create-account?token&loggedIn&email&refCode&utm_source&utm_medium&utm_campaign&utm_term&utm_content",
      templateUrl: require("@shared/templates/svelte_page.html"),
      controller: "SveltePageCtrl",
      onEnter: () => OnboardingSessionStore.initSession(OnboardingUserType.retailer),
      resolve: {
        svelteComponent: () => CreateAccount,
        email: [
          "$stateParams",
          "$window",
          "userInfo",
          function ($stateParams) {
            return $stateParams.email;
          },
        ],
        user: [
          "$http",
          "email",
          "$window",
          "userInfo",
          function ($http, email, $window) {
            return;
          },
        ],
        svelteProps: [
          "$stateParams",
          "userInfo",
          "email",
          "user",
          ($stateParams, userInfo, email, user) => {
            return { userInfo, email, user, refCode: $stateParams.refCode };
          },
        ],
      },
    });

    $stateProvider.state("layout.invite", {
      url: "/invite/:refCode?utm_source&utm_medium&utm_campaign&utm_term&utm_content",
      controller: [
        "$stateParams",
        "$state",
        ($stateParams, $state) => {
          $state.go("layout.signup", $stateParams);
        },
      ],
    });

    $stateProvider.state("layout.emailValidation", {
      url: "/start/sign-up?token&loggedIn&error&utm_source&utm_medium&utm_campaign&utm_term&utm_content",
      templateUrl: require("@shared/templates/svelte_page.html"),
      onEnter: () => OnboardingSessionStore.initSession(OnboardingUserType.retailer),
      controller: "SveltePageCtrl",
      resolve: {
        svelteComponent: () => SignUp,
        svelteProps: [
          "userInfo",
          "$rootScope",
          (userInfo, $rootScope) => {
            return {
              user: $rootScope.user || null,
              userInfo,
            };
          },
        ],
      },
    });

    $stateProvider.state("layout.passwordReset", {
      url: "/start/passwordReset?token&loggedIn&utm_source&utm_medium&utm_campaign&utm_term&utm_content",
      templateUrl: require("@shared/templates/svelte_page.html"),
      controller: "SveltePageCtrl",
      resolve: {
        svelteComponent: () => PasswordReset,
        svelteProps: [
          "$stateParams",
          function ($stateParams) {
            return {};
          },
        ],
      },
    });

    $stateProvider.state("layout.passwordResetSent", {
      url: "/start/passwordResetSent?email",
      templateUrl: require("@shared/templates/svelte_page.html"),
      controller: "SveltePageCtrl",
      resolve: {
        svelteComponent: () => PasswordResetSent,
        email: [
          "$stateParams",
          "$window",
          function ($stateParams, $window) {
            if (!$stateParams.email) {
              $window.location.href = "/start/passwordReset";
            }
            return $stateParams.email;
          },
        ],
        svelteProps: [
          "email",
          function (email) {
            return { email };
          },
        ],
      },
    });

    $stateProvider.state("layout.signedIn", {
      abstract: true,
      template: `<div ui-view style="min-height: 100%;"></div>`,
      resolve: {
        userInfo: [
          "User",
          function (User) {
            return User.loadOnboarding();
          },
        ],
      },
    });

    $stateProvider.state("layout.signedIn.referralRetailerConfirmation", {
      url: "/start/details-referral-confirmation?token&loggedIn&utm_source&utm_medium&utm_campaign&utm_term&utm_content",
      templateUrl: require("@shared/templates/svelte_page.html"),
      onEnter: () => OnboardingSessionStore.initSession(OnboardingUserType.retailer),
      controller: "SveltePageCtrl",
      params: {
        referralData: null,
      },
      resolve: {
        svelteComponent: () => ReferralRetailerConfirmation,
        svelteProps: [
          "$stateParams",
          $stateParams => {
            return { referralData: $stateParams.referralData };
          },
        ],
      },
    });

    $stateProvider.state("layout.signedIn.details", {
      url: "/start/details?token&loggedIn&utm_source&utm_medium&utm_campaign&utm_term&utm_content",
      templateUrl: require("@shared/templates/svelte_page.html"),
      onEnter: () => OnboardingSessionStore.initSession(OnboardingUserType.retailer),
      controller: "SveltePageCtrl",
      resolve: {
        svelteComponent: () => Details,
        svelteProps: [
          "$stateParams",
          "enabledStates",
          "retailers",
          ($stateParams, enabledStates, retailers) => {
            return { enabledStates, retailers };
          },
        ],
        enabledStates: [
          "CachedRequest",
          "$rootScope",
          (CachedRequest, $rootScope) =>
            CachedRequest({
              method: "GET",
              url: "api/onboarding/state_settings",
            }),
        ],
      },
    });

    $stateProvider.state("layout.signedIn.detailsManual", {
      url: "/start/details-manual?token&loggedIn&utm_source&utm_medium&utm_campaign&utm_term&utm_content",
      templateUrl: require("@shared/templates/svelte_page.html"),
      onEnter: () => OnboardingSessionStore.initSession(OnboardingUserType.retailer),
      controller: "SveltePageCtrl",
      resolve: {
        svelteComponent: () => DetailsManual,
        svelteProps: [
          "$stateParams",
          "enabledStates",
          "retailers",
          ($stateParams, enabledStates, retailers) => {
            return { enabledStates, retailers };
          },
        ],
        enabledStates: [
          "CachedRequest",
          "$rootScope",
          (CachedRequest, $rootScope) =>
            CachedRequest({
              method: "GET",
              url: "api/onboarding/state_settings",
            }),
        ],
      },
    });

    $stateProvider.state("layout.signedIn.distributors", {
      url: "/start/distributors?token&loggedIn&utm_source&utm_medium&utm_campaign&utm_term&utm_content",
      templateUrl: require("@shared/templates/svelte_page.html"),
      onEnter: () => OnboardingSessionStore.initSession(OnboardingUserType.retailer),
      controller: "SveltePageCtrl",
      resolve: {
        svelteComponent: () => Distributors,
        retailers: [
          "$rootScope",
          "$q",
          "userInfo",
          "Retailers",
          function ($rootScope, $q, userInfo, Retailers) {
            return Retailers.load({ include_distributors: "1" });
          },
        ],
        svelteProps: [
          "$stateParams",
          "retailers",
          function ($stateParams, retailers) {
            return { retailers };
          },
        ],
      },
    });

    $stateProvider.state("layout.signedIn.salesrep", {
      url: "/start/sales-rep?token&loggedIn&utm_source&utm_medium&utm_campaign&utm_term&utm_content",
      templateUrl: require("@shared/templates/svelte_page.html"),
      controller: "SveltePageCtrl",
      onEnter: () => OnboardingSessionStore.initSession(OnboardingUserType.retailer),
      resolve: {
        svelteComponent: () => SalesRep,
        retailers: [
          "$rootScope",
          "$q",
          "userInfo",
          "Retailers",
          function ($rootScope, $q, userInfo, Retailers) {
            return Retailers.load({ include_distributors: "1" });
          },
        ],
        distributorsRes: [
          "$http",
          function ($http) {
            return $http({
              method: "GET",
              url: "/api/retailer/distributors",
              params: {
                retailer_direct_add: true,
                with_integrated: true,
                with_sales_reps: true,
              },
            });
          },
        ],
        distributorsWithDomainsRes: [
          "$http",
          function ($http) {
            return $http({
              method: "GET",
              url: "/api/retailer/distributors",
              params: {
                with_integrated: true,
                with_domains: true,
              },
            }).then(res => {
              DistributorStore.set(res.data);
            });
          },
        ],
        svelteProps: [
          "$stateParams",
          "retailers",
          "distributorsRes",
          function ($stateParams, retailers, distributorsRes) {
            return {
              retailers,
              distributors: distributorsRes.data ? distributorsRes.data : [],
            };
          },
        ],
      },
    });
  },
]);

tiz.factory("httpRequestInterceptor", [
  "$rootScope",
  function ($rootScope) {
    return {
      request: function (config) {
        if (config.url) {
          config.headers["X-Tiz-Retailer-Context"] = $rootScope.currentRetailerId;
        }
        return config;
      },
    };
  },
]);
var config = function ($httpProvider) {
  $httpProvider.interceptors.push("httpRequestInterceptor");
};

config.$inject = ["$httpProvider"];
tiz.run([
  "$rootScope",
  "$state",
  function ($rootScope, $state) {
    $rootScope.$on("$stateChangeSuccess", function (evt, toState, toParams, fromState, fromParams) {
      if (sessionStorage && sessionStorage.getItem("signupProgress") && toParams.loggedIn) {
        $state.go("layout.signup." + sessionStorage.getItem("signupProgress"));
      }
    });
  },
]);

tiz.config(config);
tiz.constant("APP", "onboarding2");
